import { render } from "./InteractiveGraphicEditor.vue?vue&type=template&id=3b60a38c"
import script from "./InteractiveGraphicEditor.vue?vue&type=script&lang=js"
export * from "./InteractiveGraphicEditor.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/tools.planval.ch/staging.tools.planval.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__